

export default function formatDate8601( date ) {
  const
    offset = date.getTimezoneOffset(),
    offsetSymbol = ( function getOffsetSymbol( offset ) {
      if ( offset > 0 ) {
        return '-';
      }
      return '+';
    }( offset )),
    pad = num => {
      const norm = Math.floor( Math.abs( num ));
      return ( norm < 10 ? '0' : '' ) + norm;
    };

  return date.getFullYear() +
      '-' + pad( date.getMonth() + 1 ) +
      '-' + pad( date.getDate()) +
      'T' + pad( date.getHours()) +
      ':' + pad( date.getMinutes()) +
      ':' + pad( date.getSeconds()) +
      offsetSymbol + pad( offset / 60 ) +
      ':' + pad( offset % 60 );
}
